module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-teatopics-02.88c0195c.jpg";